import React, { useState } from 'react'
import SharePointModal from './configurationModal/SharePointModal'
import ReactModal from 'react-modal'
import WhatsappModal from './configurationModal/WhatsappModal'
import OpenAIModal from './configurationModal/OpenAIModal'
import EmailModal from './configurationModal/EmailModal'
import MapModal from './configurationModal/MapModal'
import MsTeamsModal from './configurationModal/TeamsModal'
import TeamsModal from './configurationModal/TeamsModal'
import GoogleMeetModal from './configurationModal/GoogleMeetModal'
import RazorpayModal from './configurationModal/RazorpayModal'
import PaypalModal from './configurationModal/PaypalModal'
import InstagramModal from './configurationModal/InstagramModal'

const ConfigurationPage = () => {
  const [isSharePointModalOpen, setIsSharePointModalOpen] = useState<boolean>(false)
  const [isWhatsappModalOpen1, setIsWhatsappModalOpen1] = useState<boolean>(false)
  const [isEmailModalOpen, setIsEmailModalOpen] = useState<boolean>(false)
  const [isOpenAIModalOpen2, setIsOpenAIModalOpen2] = useState<boolean>(false)
  const [isMapModalOpen, setIsMapModalOpen] = useState<boolean>(false)
  const [isTeamsModalOpen, setIsTeamsModalOpen] = useState<boolean>(false)
  const [isGoogleMeetModalOpen, setIsGoogleMeetModalOpen] = useState<boolean>(false)
  const [isRazorpayModalOpen, setIsRazorpayModalOpen] = useState<boolean>(false)
  const [isPaypalModalOpen, setIsPaypalModalOpen] = useState<boolean>(false)
  const [isInstagramModalOpen, setIsInstagramModalOpen] = useState<boolean>(false)

  const customSharePointModalStyles: ReactModal.Styles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-40%, -50%)'
    }
  }

  const openSharePointModal = () => {
    setIsSharePointModalOpen(true)
  }

  const afterOpenSharePointModal = () => {
    // Add any logic that needs to run after the modal is opened
  }

  const closeSharePointModal = () => {
    setIsSharePointModalOpen(false)
  }

  //  Whatsapp modal

  const customWhatsappModalStyles1: ReactModal.Styles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-40%, -50%)'
    }
  }

  const openWhatsapptModal1 = () => {
    setIsWhatsappModalOpen1(true)
  }

  const afterOpenWhatsapptModal1 = () => {
    // Add any logic that needs to run after the modal is opened
  }

  const closeWhatsappModal1 = () => {
    setIsWhatsappModalOpen1(false)
  }

  const openInstagramModal = () => {
    setIsInstagramModalOpen(true)
  }

  const afterOpenInstagramModal = () => {
    // Add any logic that needs to run after the modal is opened
  }

  const closeInstagramModal = () => {
    setIsInstagramModalOpen(false)
  }

  // Email

  const customEmailModalStyles: ReactModal.Styles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      borderRadius: '15px',
      border: 'none',
      boxShadow: '0 2px 8px 0 #00000029'
    }
  }

  const openEmailModal = () => {
    setIsEmailModalOpen(true)
  }

  const afterOpenEmailModal = () => {
    // Add any logic that needs to run after the modal is opened
  }

  const closeEmailModal = () => {
    setIsEmailModalOpen(false)
  }

  // Open ai

  const customOpenAIModalStyles2: ReactModal.Styles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-40%, -50%)'
    }
  }

  const openOpenAIModal2 = () => {
    setIsOpenAIModalOpen2(true)
  }

  const afterOpenOpenAIModal2 = () => {
    // Add any logic that needs to run after the modal is opened
  }

  const closeOpenAIModal2 = () => {
    setIsOpenAIModalOpen2(false)
  }

  const openMapModal = () => {
    setIsMapModalOpen(true)
  }

  const afterOpenMapModal = () => {
    // Add any logic that needs to run after the modal is opened
  }

  const closeMapModal = () => {
    setIsMapModalOpen(false)
  }

  const openTeamsModal = () => {
    setIsTeamsModalOpen(true)
  }

  const afterOpenTeamsModal = () => {
    // Add any logic that needs to run after the modal is opened
  }

  const closeTeamsModal = () => {
    setIsTeamsModalOpen(false)
  }

  const openGoogleMeetModal = () => {
    setIsGoogleMeetModalOpen(true)
  }

  const afterOpenGoogleMeetModal = () => {
    // Add any logic that needs to run after the modal is opened
  }

  const closeGoogleMeetModal = () => {
    setIsGoogleMeetModalOpen(false)
  }

  const openRazorpayModal = () => {
    setIsRazorpayModalOpen(true)
  }

  const afterOpenRazorpayModal = () => {
    // Add any logic that needs to run after the modal is opened
  }

  const closeRazorpayModal = () => {
    setIsRazorpayModalOpen(false)
  }

  const openPaypalModal = () => {
    setIsPaypalModalOpen(true)
  }

  const afterOpenPaypalModal = () => {
    // Add any logic that needs to run after the modal is opened
  }

  const closePaypalModal = () => {
    setIsPaypalModalOpen(false)
  }

  return (
    <section className='row  '>
      <div className='card h-800px '>
        <div className='d-flex '>
          <div className=' symbol-hover m-6 cursor-pointer' onClick={openOpenAIModal2}>
            <div className='symbol symbol-200px symbol-circle'>
              <img
                className='rounded-circle mt-4 w-100px h-100px'
                src='data:image/png;base64,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'
                alt='Integration logo'
              />
            </div>
            <div className='fs-5 mt-5 text-center'>Gen AI API Models</div>
          </div>

          <div className=' symbol-hover m-6 cursor-pointer ' onClick={openWhatsapptModal1}>
            <div className='symbol symbol-200px symbol-circle'>
              <img
                className='rounded-circle mt-4 w-100px h-100px'
                src='https://chatbot-project.s3.ap-south-1.amazonaws.com/botgo/assets/images/whatsapp.jpeg'
                alt='Integration logo'
              />
            </div>
            <div className=' fs-5 mt-5 text-center'>Whatsapp</div>
          </div>

          <div className=' symbol-hover m-6 cursor-pointer ' onClick={openInstagramModal}>
            <div className='symbol symbol-200px symbol-circle'>
              <img
                className='rounded-circle mt-4 w-100px h-100px'
                src='https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Instagram_icon.png/2048px-Instagram_icon.png'
                alt='Integration logo'
              />
            </div>
            <div className=' fs-5 mt-5 text-center'>Instagram</div>
          </div>

          <div className=' symbol-hover m-6 cursor-pointer' onClick={openSharePointModal}>
            <div className='symbol symbol-200px symbol-circle'>
              <img
                className='rounded-circle mt-4 w-100px h-100px'
                src='https://chatbot-project.s3.ap-south-1.amazonaws.com/botgo/assets/images/sharepoint.png'
                alt='Integration logo'
              />
            </div>
            <div className=' fs-5 mt-5 text-center'>SharePoint</div>
          </div>

          <div className=' symbol-hover m-6 cursor-pointer' onClick={openEmailModal}>
            <div className='symbol symbol-200px symbol-circle'>
              <img
                className='rounded-circle mt-4 w-100px h-100px'
                src='https://imaginethatcreative.net/blog/wp-content/uploads/2023/06/2250206.png'
                alt='Integration logo'
              />
            </div>
            <div className=' fs-5 mt-5 text-center'>Email</div>
          </div>

          <div className=' symbol-hover m-6 cursor-pointer' onClick={openMapModal}>
            <div className='symbol symbol-200px symbol-circle'>
              <img
                className='rounded-circle mt-4 w-100px h-100px'
                src='https://www.shutterstock.com/image-vector/pin-point-logo-can-be-600nw-1679653036.jpg'
                alt='Integration logo'
              />
            </div>
            <div className=' fs-5 mt-5 text-center'>Map</div>
          </div>

          <div className=' symbol-hover m-6 cursor-pointer' onClick={openGoogleMeetModal}>
            <div className='symbol symbol-200px symbol-circle'>
              <img
                className='rounded-circle mt-4 w-100px h-100px'
                src='https://botgo.s3.ap-south-1.amazonaws.com/26764431738134458703-icons8-google-meet-240.png'
                alt='Integration logo'
              />
            </div>
            <div className=' fs-5 mt-5 text-center'>Google Meet</div>
          </div>

          <div className=' symbol-hover m-6 cursor-pointer' onClick={openTeamsModal}>
            <div className='symbol symbol-200px symbol-circle'>
              <img
                className='rounded-circle mt-4 w-100px h-100px'
                src='https://botgo.s3.ap-south-1.amazonaws.com/4028931738133629333-icons8-microsoft-teams-2019-144.png'
                alt='Integration logo'
              />
            </div>
            <div className=' fs-5 mt-5 text-center'>Teams</div>
          </div>

          <div className=' symbol-hover m-6 cursor-pointer' onClick={openRazorpayModal}>
            <div className='symbol symbol-200px symbol-circle'>
              <img
                className='rounded-circle mt-4 w-100px h-100px'
                src='https://botgo.s3.ap-south-1.amazonaws.com/21998721739341391815-RazorpayImage.webp'
                alt='Integration logo'
              />
            </div>
            <div className=' fs-5 mt-5 text-center'>Razorpay</div>
          </div>

          <div className=' symbol-hover m-6 cursor-pointer' onClick={openPaypalModal}>
            <div className='symbol symbol-200px symbol-circle'>
              <img
                className='rounded-circle mt-4 w-100px h-100px'
                src='https://botgo.s3.ap-south-1.amazonaws.com/31314841739341495355-Paypall.webp'
                alt='Integration logo'
              />
            </div>
            <div className=' fs-5 mt-5 text-center'>PayPal</div>
          </div>
        </div>
      </div>

      <ReactModal
        isOpen={isSharePointModalOpen}
        onAfterOpen={afterOpenSharePointModal}
        onRequestClose={closeSharePointModal}
        style={customSharePointModalStyles}
        contentLabel='SharePoint'
      >
        <SharePointModal closeSharePointModal={closeSharePointModal} />
      </ReactModal>

      <ReactModal
        isOpen={isWhatsappModalOpen1}
        onAfterOpen={afterOpenWhatsapptModal1}
        onRequestClose={closeWhatsappModal1}
        style={customWhatsappModalStyles1}
        contentLabel='Whatsapp'
      >
        <WhatsappModal closeWhatsappModal1={closeWhatsappModal1} />
      </ReactModal>

      <ReactModal
        isOpen={isInstagramModalOpen}
        onAfterOpen={afterOpenInstagramModal}
        onRequestClose={closeInstagramModal}
        style={customWhatsappModalStyles1}
        contentLabel='Instagram'
      >
        <InstagramModal closeInstagramModal={closeInstagramModal} />
      </ReactModal>

      <ReactModal
        isOpen={isOpenAIModalOpen2}
        onAfterOpen={afterOpenOpenAIModal2}
        onRequestClose={closeOpenAIModal2}
        style={customOpenAIModalStyles2}
        contentLabel='OpenAI'
      >
        <OpenAIModal closeOpenAIModal2={closeOpenAIModal2} />
      </ReactModal>

      <ReactModal
        isOpen={isEmailModalOpen}
        onAfterOpen={afterOpenEmailModal}
        onRequestClose={closeEmailModal}
        style={customEmailModalStyles}
        contentLabel='Email'
      >
        <EmailModal closeEmailModal={closeEmailModal} />
      </ReactModal>

      <ReactModal
        isOpen={isMapModalOpen}
        onAfterOpen={afterOpenMapModal}
        onRequestClose={closeMapModal}
        style={customEmailModalStyles}
        contentLabel='Map'
      >
        <MapModal closeMapModal={closeMapModal} />
      </ReactModal>

      <ReactModal
        isOpen={isGoogleMeetModalOpen}
        onAfterOpen={afterOpenGoogleMeetModal}
        onRequestClose={closeGoogleMeetModal}
        style={customEmailModalStyles}
        contentLabel='Google Meet'
      >
        <GoogleMeetModal closeGoogleMeetModal={closeGoogleMeetModal} />
      </ReactModal>

      <ReactModal
        isOpen={isTeamsModalOpen}
        onAfterOpen={afterOpenTeamsModal}
        onRequestClose={closeTeamsModal}
        style={customEmailModalStyles}
        contentLabel='Teams'
      >
        <TeamsModal closeTeamsModal={closeTeamsModal} />
      </ReactModal>

      <ReactModal
        isOpen={isRazorpayModalOpen}
        onAfterOpen={afterOpenRazorpayModal}
        onRequestClose={closeRazorpayModal}
        style={customEmailModalStyles}
        contentLabel='Razorpay'
      >
        <RazorpayModal closeRazorpayModal={closeRazorpayModal} />
      </ReactModal>

      <ReactModal
        isOpen={isPaypalModalOpen}
        onAfterOpen={afterOpenPaypalModal}
        onRequestClose={closePaypalModal}
        style={customEmailModalStyles}
        contentLabel='Paypal'
      >
        <PaypalModal closePaypalModal={closePaypalModal} />
      </ReactModal>
    </section>
  )
}

export default ConfigurationPage
